import { Components } from "appworks/components/components";
import { Layers } from "appworks/graphics/layers/layers";
import { gameState } from "appworks/model/game-state";
import { Services } from "appworks/services/services";
import { TransactionService } from "appworks/services/transaction/transaction-service";
import { State } from "appworks/state-machine/states/state";
import { UIFlag, uiFlags } from "appworks/ui/flags/ui-flags";
import { BannerComponent } from "slotworks/components/banner/banner-component";
import { BetBarComponent } from "slotworks/components/betbar/bet-bar-component";
import { AbstractMatrixComponent } from "slotworks/components/matrix/abstract-matrix-component";
import { FreespinRecord } from "slotworks/model/gameplay/records/freespin-record";
import { slotDefinition } from "slotworks/model/slot-definition";

export interface RecoverFreespinsConfig {
    setWinningsToTotalWin: boolean;
    setToFreespinsReelset: boolean;
}
export class RecoverFreespinsModeState extends State {

    protected config: RecoverFreespinsConfig = {
        setWinningsToTotalWin: false,
        setToFreespinsReelset: false
    };

    constructor(config?: Partial<RecoverFreespinsConfig>) {
        super();

        if (config) {
            this.config = { ...this.config, ...config };
        }
    }

    public onEnter() {
        const gameplay = gameState.getCurrentGame();
        const record = gameplay.getCurrentRecord() as FreespinRecord;

        // Update smart button count
        uiFlags.set(UIFlag.FREE_SPINS, true);

        // If we're about to recover into a retrigger, deduct it's awarded spins from the initial state.
        const retriggerFreespins = gameplay.getCurrentRecord().getFreespinsWon();

        let totalFreespins = gameplay.getTotalFreespinsWon();
        if (retriggerFreespins > 0) {
            totalFreespins -= retriggerFreespins;
        }
        Components.get(BetBarComponent).setTotalFreespins(totalFreespins);

        // Dont include current freespin as a played one
        Components.get(BetBarComponent).setFreespinsPlayed(Math.max(0, gameplay.getFreespinsPlayed()));

        let winnings = gameplay.getCurrentBranchWin();
        if (this.config.setWinningsToTotalWin) {
            winnings = gameplay.getTotalWin();
        }
        winnings -= record.wonAmount;

        Services.get(TransactionService).setWinnings(0, winnings).execute();
        Services.get(TransactionService).setBalance(gameplay.balance);

        if (this.config.setToFreespinsReelset) {
            this.setReelset();
        }

        this.recoverFreespinsElements();

        this.complete();
    }

    protected recoverFreespinsElements() {
        if (Layers.get("Background")?.hasScene("freespins")) {
            Layers.get("Background").jumpToScene("freespins");
        }
        if (Layers.get("MatrixBackground")?.hasScene("freespins")) {
            Layers.get("MatrixBackground").jumpToScene("freespins");
        }
        if (Layers.get("MatrixForeground")?.hasScene("freespins")) {
            Layers.get("MatrixForeground").jumpToScene("freespins");
        }
        if (Layers.get("Header")?.hasScene("freespins")) {
            Layers.get("Header").jumpToScene("freespins");
        }

        if (Components.get(BannerComponent)) {
            Components.get(BannerComponent).setMode("freespins");
        }
    }

    protected setReelset() {
        if (slotDefinition.reelsets.get("freespins")) {
            Components.get(AbstractMatrixComponent).setCustomReelset(slotDefinition.reelsets.get("freespins"));
        }
    }
}
